/** @jsx jsx */
import React from 'react';
import { jsx } from '@emotion/core';
import { SafePureComponent } from '../../../../utils/SafePureComponent';
import { isMobileOnly } from 'react-device-detect';
import {
  itemsSubContainer,
  itemsSubContainerAbsolute,
  itemsSubContainerSelected,
} from '../index.styles';
import Card from '../Card';

const ITEMS_COUNT = 32;
let offset = 0;

class InfiniteContainer extends SafePureComponent {
  ref = null;

  constructor(props) {
    super(props);
    this.state = {
      scrollPosition: 0,
      scrollPaused: false,
      calculatedItems: new Array(
        isMobileOnly ? props.Items.length : ITEMS_COUNT,
      )
        .fill(1)
        .map((_, index) => ({
          ...props.Items[index % props.Items.length],
          id: `card-${index + 1}`,
        })),
    };
  }

  setRef = ref => (this.ref = ref);

  scrollContainer = () => {
    const { selectedId } = this.props;
    const { scrollPaused, calculatedItems } = this.state;
    const topElement = document.getElementById(calculatedItems[0].id);

    if (scrollPaused || !this.ref || !topElement || selectedId) {
      return;
    }
    offset = offset + 1;

    if (offset >= topElement.offsetHeight + 20) {
      offset = 0;
      const { calculatedItems } = this.state;
      this.setState({
        calculatedItems: [
          ...calculatedItems.slice(1, calculatedItems.length),
          calculatedItems[0],
        ],
      });
    }
    this.ref.scrollTop = offset;
  };

  onCardHover = () => this.setState({ scrollPaused: true });

  onCardLeave = () => this.setState({ scrollPaused: false });

  componentDidMount() {
    super.componentDidMount();
    if (!isMobileOnly) {
      setInterval(this.scrollContainer, 20);
    }
  }

  safeRender() {
    const { calculatedItems } = this.state;
    const { onClick, selectedId } = this.props;

    return (
      <div
        css={[
          selectedId ? itemsSubContainerSelected : itemsSubContainer,
          isMobileOnly ? null : itemsSubContainerAbsolute,
        ]}
        ref={this.setRef}
      >
        {calculatedItems.map((Item, i) => (
          <Card
            selected={selectedId === Item.id}
            Item={Item}
            key={`card-${i}`}
            onClick={() => onClick(Item.id)}
            onHover={this.onCardHover}
            onLeave={this.onCardLeave}
          />
        ))}
      </div>
    );
  }
}

export default InfiniteContainer;
